import React from "react";
import { Segment, SegmentProps, Icon } from "semantic-ui-react";
import ICategory from "../../interfaces/ICategory";

interface IFormCategoryMenuItem {
    category: ICategory;
    onClick?: (e: any, categoryId: number) => void;
    segmentProps?: Partial<SegmentProps>
}

const FormCategoryMenuItem: React.FC<IFormCategoryMenuItem> = (props) => {
    const { category, onClick, segmentProps = {} } = props;

    const handleClick = (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        onClick instanceof Function && onClick(e, category.id)
    }
    return (
        <Segment textAlign="center" {...segmentProps} onClick={handleClick}>
            {category.icon ? <><Icon name={category.icon} color="grey" /> <br /></> : null}
            {category.name}
        </Segment>
    );
};

export default FormCategoryMenuItem;
